<template>
    <v-container fluid class="pa-0 stepper-wrap">
        <v-row no-gutters class="stepper">
            <v-col v-for="(step, i) in steps" :key="step.label" class="step" :class="{
                active: i === activeStep,
                completed: i < activeStep,
                last: i === steps.length - 1
            }">
                <div class="step-content">
                    <span v-for="(w, wi) in splitWords(step.label)" :key="`${step.label}-${wi}`" class="word">{{ w
                    }}</span>
                </div>
                <div v-if="i < steps.length - 1" class="arrow" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'ListingStepper',
    props: {
        activeStep: { type: Number, default: 0 },
        steps: {
            type: Array,
            default: () => [
                { label: 'Listing Posted' },
                { label: 'Booking Requested' },
                { label: 'Pending Confirmation' },
                { label: 'Pending Payment' },
                { label: 'Booking Confirmed' },
                { label: 'Final Payment' },
                { label: 'Set Sail' },
                { label: 'End Summary' },
            ]
        }
    },
    methods: {
        splitWords(s) {
            return String(s || '').trim().split(/\s+/) // each word becomes its own line
        }
    }
}
</script>

<style scoped>
.stepper-wrap {
    border-radius: 10px;
    overflow: hidden;
}

/* bar container */
.stepper {
    display: flex;
    border: none;
    /* ✅ remove border so no seam */
    border-radius: 10px;
    overflow: hidden;
}

/* each step cell */
.step {
    position: relative;
    display: flex;
    align-items: center;
    height: 60px;
    background: #FFFFFF;
    color: #112a3a;

    padding: 10px;
    border: none;
}

.word {
    font-weight: 700;
    font-size: 0.9rem;
    line-height: 1.3;
}

/* center labels */
.step-content {
    flex: 1;
    text-align: center;
    padding-inline: 20px;
    z-index: 1;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* arrow between steps */
.arrow {
    position: absolute;
    top: 0;
    right: -30px;
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 30px solid #FFFFFF;
    z-index: 2;
    margin: 0;
}

/* active (blue) */
.step.active {
    background: #4A4E74;
    color: #fff;
}

.step.active .arrow {
    border-left-color: #4A4E74;
}

/* completed (lighter blue) */
.step.completed {
    background: #4A4E74;
    color: #fff;
}

.step.completed .arrow {
    border-left-color: #4A4E74;
}

/* remove arrow on last step */
.step.last .arrow {
    display: none;
}

/* small screens */
@media (max-width: 640px) {
    .step {
        font-size: .85rem;
        height: 44px;
    }

    .arrow {
        right: -20px;
        border-top-width: 22px;
        border-bottom-width: 22px;
        border-left-width: 20px;
    }
}
</style>
